import dayjs            from 'dayjs';
import { computed }     from 'mobx';
import ApiModel         from './globals/ApiModel';
import { getIdFromIri } from 'utils/apiTools';
import ShowModel        from './ShowModel';

export default class DemandConfigModel extends ApiModel {
  static get path() {
    return '/backend/demand_configs/{?id}';
  }

  @computed
  get demandsAfter() {
    return this.get('demandsAfter', '');
  }

  @computed
  get demandsAfterDate() {
    return this.demandsAfter ? dayjs(this.demandsAfter) : null;
  }

  @computed
  get demandsBefore() {
    return this.get('demandsBefore', '');
  }

  @computed
  get demandsBeforeDate() {
    return this.demandsBefore ? dayjs(this.demandsBefore) : null;
  }

  @computed
  get demandType() {
    return this.get('demandType', '');
  }

  @computed
  get demandTypeIri() {
    return this.get('demandType', '');
  }

  @computed
  get surfaceMin() {
    return this.get('surfaceMin');
  }

  @computed
  get showId() {
    return getIdFromIri(ShowModel, this.get('show'));
  }
}
